import * as React from 'react';

const ThumbsUpChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="thumbs-up-chunky_svg__eds-icon--thumbs-up-chunky_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <g>
            <path d="M5 10h2L6 20H4zm3 0l7-5.95A2.53 2.53 0 0117.5 8l-1.43 2h2.69a1 1 0 011 1 1.23 1.23 0 010 .19l-1.26 6.37A3 3 0 0115.56 20H9.25a2 2 0 01-2-2 1.34 1.34 0 010-.2l.69-6.8zm2 1l-.7 7h6.31a1 1 0 001-.81l1-5.16h-5.44l3.7-5.16a.49.49 0 00.13-.41.53.53 0 00-.24-.37z" />
        </g>
    </svg>
);

ThumbsUpChunkySvg.displayName = 'ThumbsUpChunkySvg';
export default ThumbsUpChunkySvg;
